/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A unique id to identify a session.
 *
 * @example "00112233-4455-6677-8899-aabbccddeeff"
 */
export const ATTR_SESSION_ID = 'session.id';
//# sourceMappingURL=semconv.js.map